import React from 'react';
import { IconContext } from 'react-icons';
import { IoCloseOutline } from 'react-icons/io5';
import { FaChevronRight, FaHeart } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { navClosed } from '../../redux/navigation/navigation';
import navLinks from '../../utils/navLinks';
import socialLinks from '../../utils/socialLinks';
import styles from './navigation.module.scss';

const Navigation = () => {
  const dispatch = useDispatch();
  const navState = useSelector((state) => state.navigation);
  const { open } = navState;

  const handleClick = () => {
    dispatch(navClosed());
  };

  return (
    <section
      className={`
      ${styles.nav_section}
      ${
        open
          ? 'text-primary h-screen flex-col fixed top-0 left-0 right-0 bottom-0 z-10 bg-white overflow-hidden'
          : 'translate-x-[-100%] absolute top-0 left-0 right-0'
      }`}
    >
      <button type="button" className="text-3xl" onClick={handleClick}>
        <IoCloseOutline />
      </button>
      <nav className="flex flex-col justify-betwee">
        <ul className="leading-10 uppercase">
          {navLinks.map((link) => (
            <li className="" key={link.name}>
              <NavLink
                to={link.link}
                onClick={handleClick}
                className="flex justify-between items-center"
              >
                <span>{link.name}</span>
                <FaChevronRight />
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <section className="w-full absolute bottom-0 mb-6 self-center flex flex-col items-center">
        <ul
          className={`${styles.social_media_wrapper} flex justify-between mb-7 items-center`}
        >
          {socialLinks.map((link) => (
            <li key={link.name}>
              <a href={link.link} target="_blank" rel="noreferrer">
                {link.icon}
              </a>
            </li>
          ))}
        </ul>
        <div
          className={`${styles.footer_copy_right} text-primary flex justify-center items-center text-center`}
        >
          <p className="">
            Copyright &copy; 2020 COMIGRA. Tous droits reserves |
          </p>
          <p className="flex justify-center items-center">
            Made with
            <IconContext.Provider value={{ className: 'px-1' }}>
              <FaHeart />
            </IconContext.Provider>
            by
            <a
              href="https://www.neutral.com"
              title="neutral"
              target="blank"
              className="px-1"
            >
              Neutral_Team
            </a>
          </p>
        </div>
      </section>
    </section>
  );
};

export default Navigation;
